import Wrapper from './components/Wrapper'
import './login.scss'
import FirstStep from './components/FirstStep'
import { useState } from 'react'
import { FirstStepData } from './models'
import { useMutation } from '@tanstack/react-query'
import { verifyCode } from '../../services/login/api'
import SecondStep from './components/SecondStep'
import useAppStore from '../../stores/app'
import { useSnackbar } from 'notistack'
import { stringifyError } from '../../utils/utils-functions'

const POLICY_CONFIRM_KEY = 'POLICY_CONFIRM'

const Login = () => {
  const { setToken } = useAppStore()
  const { enqueueSnackbar } = useSnackbar()

  const [step, setStep] = useState<'step-1' | 'step-2' | 'step-3' >('step-1')
  const [userData, setUserData] = useState<FirstStepData>()
  const { mutateAsync: verifyCodeRequest, isLoading: verifyCodeProcessing } = useMutation(verifyCode)

  const handlerVerificationCode = async (data: FirstStepData) => {
    try {
      const email = data.email.includes('@') ? data.email : `${data.email}@nyct.com`
      const { token } = await verifyCodeRequest({ email, password: data.password })
      setToken(token)
    } catch (error) {
      console.error(error)
      enqueueSnackbar(stringifyError(error), { variant: 'error' })
    }
  }

  const handlerVerificationPolicy = (data: FirstStepData) => {
    setUserData(data)
    if (localStorage.getItem(POLICY_CONFIRM_KEY)) {
      handlerVerificationCode(data)
    } else {
      setStep('step-2')
    }
  }

  const handlerAgreePolicy = () => {
    localStorage.setItem(POLICY_CONFIRM_KEY, 'true')
    handlerVerificationCode(userData as FirstStepData)
  }

  const handlerCancelPolicy = () => setStep('step-1')

  return (
    <Wrapper>
      {step === 'step-1' ? (
        <FirstStep
          onSubmit={handlerVerificationPolicy}
          loginProcessing={verifyCodeProcessing} />
      ) : null}
      {step === 'step-2' ? (
        <SecondStep
          loginProcessing={verifyCodeProcessing}
          onAgree={handlerAgreePolicy}
          onCancel={handlerCancelPolicy} />
      ) : null}
    </Wrapper>
  )
}

export default Login
